<template>
  <div v-if="stats" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
    <!-- Card 1: Total Personal -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Personal</span>
        <div class="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center text-lg">
          <i class="fa fa-users" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-gray-900">{{ stats.total_employees ?? 0 }}</p>
        <p class="text-xs text-gray-500 mt-1 flex items-center gap-1.5">
          <span class="text-emerald-600 font-semibold">{{ stats.active_employees ?? 0 }} activos</span>
          <span>•</span>
          <span class="text-gray-400">{{ stats.inactive_employees ?? 0 }} inactivos</span>
        </p>
      </div>
    </div>

    <!-- Card 2: Total Pagado -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Total Pagado</span>
        <div class="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center text-lg">
          <i class="fa fa-coins" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-emerald-600">{{ formatUSD(stats.total_spent_payroll ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">
          Este mes: <strong class="text-gray-700 font-semibold">{{ formatUSD(stats.this_month_spent_payroll ?? 0) }}</strong>
        </p>
      </div>
    </div>

    <!-- Card 3: Por Liquidar -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Por Liquidar</span>
        <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center text-lg">
          <i class="fa fa-hand-holding-usd" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-amber-600">{{ formatUSD(stats.total_pending_payroll ?? 0) }}</p>
        <p class="text-xs text-gray-400 mt-1">
          {{ stats.pending_shifts_count ?? 0 }} turnos listos para pago
        </p>
      </div>
    </div>

    <!-- Card 4: Turnos Pendientes -->
    <div class="bg-white rounded-xl p-5 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 uppercase tracking-wider">Turnos Pendientes</span>
        <div class="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center text-lg">
          <i class="fa fa-clock" />
        </div>
      </div>
      <div class="mt-3">
        <p class="text-2xl font-bold text-purple-600">{{ stats.pending_shifts_count ?? 0 }}</p>
        <p class="text-xs text-gray-400 mt-1 truncate">
          <template v-if="stats.last_payment">
            Último: <span class="font-mono font-semibold text-gray-700">#{{ stats.last_payment.reference_number }}</span>
          </template>
          <template v-else>
            Sin liquidaciones previas
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaysheetStats',

  props: {
    stats: {
      type: Object,
      default: () => ({
        total_employees: 0,
        active_employees: 0,
        inactive_employees: 0,
        total_spent_payroll: 0,
        this_month_spent_payroll: 0,
        total_pending_payroll: 0,
        pending_shifts_count: 0,
        last_payment: null,
      }),
    },
  },

  methods: {
    formatUSD(val) {
      const num = parseFloat(val) || 0
      return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },
}
</script>
